import { useEffect, useRef, useState } from 'react';
import TopicGroupEdit from './TopicGroupEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../../utilsTsx/components/system/columnshead';
import { Tag } from 'antd';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const apiId = 'topicGroup';

    const [fetchData, setFetchData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setFetchData(() => ref.current.fetchData);
        }
    }, []);

    // 表头
    const columnsHead = [
        {
            title: '主题组名',
            dataIndex: 'groupName'
        },
        {
            title: '排序',
            dataIndex: 'sort'
        },
        {
            title: '状态',
            dataIndex: 'isUse',
            render: (val: boolean) =>
                val
                    ? <Tag color="green">启用</Tag>
                    : <Tag color="red">关闭</Tag>
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '主题组',
        apiId,
        columns,
        serviceId: 'mf',
        editOptions: {
            Editor: TopicGroupEdit
        }
    };

    return (
        <>
            <WebUniversal {...extendProps} ref={ref} />
        </>
    );
};

export default WebComponent;